/**
 * Navigation Configuration
 * 
 * This file controls which navigation items are displayed in the sidebar.
 * You can easily switch between application navigation and template examples.
 */

import navigationItems from './navigationItems';
import templateItems from './templateItems';

// Configuration flags
const SHOW_TEMPLATE_ITEMS = false; // Set to true to show template/demo items
const SHOW_APPLICATION_ITEMS = true; // Set to false to hide application items

/**
 * Combine navigation sections based on configuration
 */
const getNavigationSections = () => {
  const sections = [];

  if (SHOW_APPLICATION_ITEMS) {
    sections.push({
      label: '', // Empty label for main application items
      content: navigationItems
    });
  }

  if (SHOW_TEMPLATE_ITEMS) {
    sections.push({
      label: 'Template Examples',
      content: templateItems
    });
  }

  return sections;
};

export default getNavigationSections();
export { navigationItems, templateItems };

